export default function applySupportPhone(cityName) {
  const phones = $('article.v4.storages_map').data('support_phones');
  if (!phones) { return; }

  const phone = phones.cities[cityName] || phones.default;
  const regionalCssClasses = Object.values(phones.cities)
    .map(({ cssClass }) => cssClass)
    .join(' ');

  // класс подмены calltouch живёт на обёртке ссылки, а не на самой ссылке
  $('[data-support_phone]').each((_index, node) => {
    $(node)
      .removeClass(regionalCssClasses)
      .addClass(phone.cssClass || '')
      .find('a')
      .attr('href', phone.url)
      .text(phone.label);
  });

  // модалка контактов монтируется по первому клику и читает пропсы
  // из data триггера через jquery, поэтому обновляем и кэш .data()
  $('[data-phone_url]').each((_index, node) => {
    $(node)
      .attr('data-phone_url', phone.url)
      .data('phone_url', phone.url)
      .attr('data-phone_class', phone.cssClass || '')
      .data('phone_class', phone.cssClass || '');
  });
}
